import React, { useState, useEffect } from "react";
import { authActions } from "../../../redux-store";
import { useDispatch, useSelector } from "react-redux";
import backend from "../../../api";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, easeOut, AnimatePresence } from "framer-motion";
import Classes from "./Auth.module.css";
import CryptoJS from "crypto-js";

const LoadingSpinner = () => (
  <div className="loadingio-spinner-eclipse-nq4q5u6dq7r">
    <div className="ldio-x2uulkbinbj">
      <div></div>
    </div>
  </div>
);

const fadeInLeft = {
  initial: { opacity: 0, x: -10 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -10 },
  transition: { duration: 0.5, ease: easeOut, delay: 0.3 },
};

function CustomerSignup() {
  const [state, setState] = useState("signup"); // 'signup' | 'verify' | 'createProfile'
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const location = useLocation();

  // signup creds
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");

  // create profile (basic) captured here then finalized on onboarding page
  const [profileName, setProfileName] = useState("");
  const [profilePhone, setProfilePhone] = useState("");

  // ui + errors
  const [loading, setLoading] = useState(false);
  const [incorrectError, setincorrectError] = useState(false);
  const [showEye, setshowEye] = useState(false);
  const [showEye2, setshowEye2] = useState(false);
  const [passwordMatchingError, setpasswordMatchingError] = useState(false);
  const [passwordLengthError, setpasswordLengthError] = useState(false);
  const [userAlreadyExistError, setUserAlreadyExistError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [codeSentMsg, setcodeSentMsg] = useState(false);
  const [IncorrectCode, setIncorrectCode] = useState(false);
  const [userCode, setUserCode] = useState("");

  // simple 4-digit code
  const code = Math.floor(Math.random() * 10000).toString();
  const message = `verification code is ${code}`;

  const switchToVerify = () => {
    setincorrectError(false);
    if (password !== confirmPassword) {
      setpasswordMatchingError(true);
      setTimeout(() => setpasswordMatchingError(false), 5000);
      return;
    }
    if (password && password.length <= 5) {
      setpasswordLengthError(true);
      setTimeout(() => setpasswordLengthError(false), 10000);
      return;
    }
    sendMail();
  };

  const sendMail = async () => {
    setLoading(true);
    try {
      const encrypted = CryptoJS.AES.encrypt(code, "secret-key").toString();
      sessionStorage.setItem("encryptedData", encrypted);

      const body = { username: "User", email, message };
      const resp = await backend.post("/verify/sendemail", body);

      if (resp.status === 200) {
        setcodeSentMsg(true);
        setTimeout(() => setcodeSentMsg(false), 60000);
        setState("verify");
      } else if (resp.status === 400) {
        setUserAlreadyExistError(true);
        setTimeout(() => setUserAlreadyExistError(false), 10000);
      } else if (resp.status === 500) {
        alert("Server error occurred. Please try again later.");
      } else {
        alert("An unexpected error occurred. Please try again.");
      }
    } catch (error) {
      setUserAlreadyExistError(true);
      setErrorMessage(error?.response?.data?.message);
      setTimeout(() => {
        setUserAlreadyExistError(false);
        setErrorMessage("");
      }, 10000);
    } finally {
      setLoading(false);
    }
  };

  // completes account creation with role=customer
  const signUpCustomer = async () => {
    const role = "customer";
    setLoading(true);
    try {
      if (email && password) {
        if (email.includes("@") && password.length > 5) {
          const isSignup = await dispatch(authActions.signUp(email, password, role));
          if (isSignup) {
            setLoading(false);
            // go to customer onboarding (studio/company selection/creation)
            navigateTo("/onboarding/customer", {
              state: {
                profilePrefill: {
                  name: profileName || "",
                  phone: profilePhone || "",
                },
                from: location?.state?.data === "toTemplate" ? "toTemplate" : undefined,
              },
            });
            return true;
          }
          setLoading(false);
          setincorrectError(true);
          return false;
        } else {
          setLoading(false);
          setpasswordLengthError(true);
          setTimeout(() => setpasswordLengthError(false), 10000);
          return false;
        }
      } else {
        setLoading(false);
        setpasswordLengthError(true);
        setTimeout(() => setpasswordLengthError(false), 10000);
        return false;
      }
    } catch (e) {
      setLoading(false);
      alert("Network Error");
      return false;
    }
  };

  const handleSignUpSubmit = (e) => {
    e.preventDefault();
    if (email?.startsWith("demo.evala")) {
      signUpCustomer();
    } else {
      switchToVerify();
    }
  };

  const onCLickVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    const encryptedDataFromStorage = sessionStorage.getItem("encryptedData");
    if (encryptedDataFromStorage) {
      const bytes = CryptoJS.AES.decrypt(encryptedDataFromStorage, "secret-key");
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

      if (userCode === decryptedData) {
        setLoading(false);
        // after verification -> create account and push to onboarding
        await signUpCustomer();
      } else {
        setIncorrectCode(true);
        setLoading(false);
        setTimeout(() => setIncorrectCode(false), 1000);
      }
    }
  };

  return (
    <>
      <div className={Classes.signUp}>
        {/* LEFT SIDE */}
        <div className={Classes.signUpGridLeft}>
          <AnimatePresence mode="wait">
            {/* SIGNUP */}
            {state === "signup" && (
              <motion.div key="signup" {...fadeInLeft}>
                <form onSubmit={handleSignUpSubmit} className={Classes.signUpInnerCon}>
                  <div onClick={() => { navigateTo('/') }} className={Classes.miniLogo2} style={{ textDecoration: "none", cursor: 'pointer' }}>
                    <div className="logo">
                      <img src="/assets/images/logo.png" alt="logo" />
                    </div>
                  </div>

                  <h5 className={Classes.heading2}>Sign Up</h5>
                  <p className={Classes.subtitle} style={{ textAlign: "start" }}>
                    Harness the power of LightTrack to instantly search, filter, and export lighting fixture data — all from one clean, intuitive interface
                  </p>

                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Enter your email"
                    required
                    className={`${`${Classes.inputField} ${Classes.mb20}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ""}`}
                    style={{ width: "100%" }}
                  />

                  <div className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ""}`}>
                    <input
                      onChange={(e) => setPassword(e.target.value)}
                      type={showEye ? "text" : "password"}
                      placeholder="Enter your password"
                      required
                    />
                    {/* {showEye ? (
                      <svg onClick={() => setshowEye(!showEye)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                        <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80z" />
                      </svg>
                    ) : (
                      <svg onClick={() => setshowEye(!showEye)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                        <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4z" />
                      </svg>
                    )} */}
                  </div>

                  <div className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ""}`}>
                    <input
                      onChange={(e) => setconfirmPassword(e.target.value)}
                      type={showEye2 ? "text" : "password"}
                      placeholder="Confirm password"
                      required
                    />

                  </div>



                  <p className={Classes.signupLink} style={{ maxWidth: "100%" }}>
                    By creating an account, you agree to the
                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                      <button type="button" className={Classes.linkButton}> Privacy Policy </button>
                    </a>
                    <span> and </span>
                    <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">
                      <button type="button" className={Classes.linkButton}> Terms of Service </button>
                    </a>
                  </p>

                  <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading}>
                    Create an account
                    {loading && <LoadingSpinner />}
                  </button>

                  <p className={Classes.signupLink2}>
                    Have an account?
                    <button type="button" onClick={() => navigateTo("/login")} className={Classes.linkButton}>
                      Sign in
                    </button>
                  </p>
                </form>
              </motion.div>
            )}

            {/* VERIFY */}
            {state === "verify" && (
              <motion.div
                key='verify'
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -10 }}
                transition={{
                  duration: 0.5,
                  ease: easeOut,
                  delay: 0.3
                }}
              >
                <form onSubmit={onCLickVerify} className={Classes.signUpInnerCon}>
                  <div onClick={() => { navigateTo('/') }} className={Classes.miniLogo2} style={{ textDecoration: 'none', cursor: 'pointer' }} >
                    <div className='logo' >
                      <img src='/assets/images/logo.png' alt='logo' />
                    </div>
                  </div>
                  <h1 className={Classes.heading2}>Enter verification code</h1>
                  {codeSentMsg && <p className={Classes.subtitle} style={{ textAlign: 'start' }} > A code was sent to your email </p>}
                  <br />
                  <input
                    onChange={(e) => setUserCode(e.target.value)}
                    type="number"
                    value={userCode}
                    placeholder="Enter your code here"
                    required
                    className={`${`${Classes.inputField} ${Classes.mb10}`} ${incorrectError ? Classes.inputError : ''}`}
                    style={{ width: '100%' }}
                  />
                  {IncorrectCode && <p className={Classes.error}>*Incorrect code.</p>}
                  <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                    Verify
                    {loading && <LoadingSpinner />}
                  </button>
                  <p className={Classes.signupLink2}>
                    Haven't received the code?
                    <button type="button" onClick={() => switchToVerify()} className={Classes.linkButton}>
                      Resend code
                    </button>
                  </p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </form>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* RIGHT SIDE */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, ease: easeOut }}
          className={Classes.signUpGridRight}
        >
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, ease: easeOut, delay: 0.3 }}
            className={Classes.signUpInnerCon2}
          >
            <h5 className={Classes.title3}>
              Sign Up for Your 14 Day Free <br /> Trial Today
            </h5>
            <br />
            <div className={Classes.infoElem}>
              <div className={Classes.infoImgBox}>
                <img src="/assets/icons/signin1.png" draggable={false} alt="" />
              </div>
              <div className={Classes.infoElemRight}>
                <h5 className={Classes.title5}>Powerful Fixture Search</h5>
                <h5 className={Classes.miniText2}>
                  Instantly filter lighting products by specs like beam angle, wattage, and color temp.
                </h5>
              </div>
            </div>
            <div className={Classes.infoElem}>
              <div className={Classes.infoImgBox}>
                <img src="/assets/icons/signin2.png" draggable={false} alt="" />
              </div>
              <div className={Classes.infoElemRight}>
                <h5 className={Classes.title5}>Export-Ready Output</h5>
                <h5 className={Classes.miniText2}>
                  Download spec sheets or Excel files formatted for documentation and team sharing.
                </h5>
              </div>
            </div>
            <div className={Classes.infoElem}>
              <div className={Classes.infoImgBox}>
                <img src="/assets/icons/signin3.png" draggable={false} alt="" />
              </div>
              <div className={Classes.infoElemRight}>
                <h5 className={Classes.title5}>Organized Project Lists</h5>
                <h5 className={Classes.miniText2}>
                  Save selected fixtures to custom lists and manage them across multiple projects on your account.
                </h5>
              </div>
            </div>
            <div className={Classes.infoElem}>
              <div className={Classes.infoImgBox}>
                <img src="/assets/icons/signin4.png" draggable={false} alt="" />
              </div>
              <div className={Classes.infoElemRight}>
                <h5 className={Classes.title5}>Clean, Modern UI</h5>
                <h5 className={Classes.miniText2}>
                  Work faster with an intuitive, distraction-free interface that puts lighting specs front and center—no clutter, just clarity.
                </h5>
              </div>
            </div>
          </motion.div>
          <img src="/assets/images/auth-bg.png" alt="" aria-hidden="true" className={Classes.authBg} draggable={false} />
        </motion.div>
      </div>
    </>
  );
}

export default CustomerSignup;
